module.exports = __webpack_public_path__ + "media/images/shark/Leona_1-p-500-f609512b723532e07d4ea51ed8ebeb8e.jpeg";